import { Platform, StyleSheet } from 'react-native';
import Theme from 'Theme';

const defaultStyles = {
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        marginTop: 10
    },
    primaryHeaderText: {
        fontFamily: Theme.ultraFont,
        color: Theme.primaryTextColor,
        /*
         * Fix weird font weight on android, we must explicitly say it is 'normal'.
         * Probably issue with react-navigation styles
         */
        fontWeight: Platform.OS === 'ios' ? '900' : 'normal',
        fontSize: 22
    },
    secondaryHeaderText: {
        fontFamily: Theme.regularFont,
        color: Theme.secondaryTextColor,
        fontSize: 22
    }
};

export default StyleSheet.create(defaultStyles);
